import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const EngagementTools = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 et-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                    <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Elevate Engagement, <br/>Ignite Wellness</Trans>
                    </h1>
                    <p className="hero-para font-weight-semibold no-br">
                        <Trans>Foster a vibrant community, conduct <br/>challenges and celebrate achievements.</Trans>
                    </p>
                    <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Let's Talk</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <div className="features-label red-font">
                                <Trans>Social Feed & Community</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Connect, Share, Inspire!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Encourage your employees to join the fitness community. <br/><br/>Motivate them to continually enhance their fitness journeys by sharing their achievements on multiple platforms with Sweaty Selfies. <br/><br/>Foster mutual support through likes, shares, and comments on fitness posts to cultivate a remarkable social wellness experience!</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080505/VantageFit/2023/Engagement_Tool-Connect_Share_Inspire.webp`)} loading='lazy' alt="Connect, Share, Inspire!" width="500" height="604"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <div className="features-label green-font">
                                    <Trans>Leaderboards & Challenges</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Compete for <br/>Wellness Excellence!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Organize wellness challenges, ignite the motivation to achieve health goals through friendly competition and earn badges. <br/><br/>Provide a platform that offers opportunities for healthy competition with both individual and team leaderboards!</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 cta-img'>
                            <div className='col-12 d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080506/VantageFit/2023/Engagement_Tool-Compete_for_Wellness_Excellence.webp`)} loading='lazy' alt="Compete for Wellness Excellence!" width="500" height="683"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <div className="features-label orange-font">
                                    <Trans>Badges & Achievements</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Celebrate Every Milestone!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Celebrate your employees achievements with badges and rewards, fostering a culture of wellness.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080507/VantageFit/2023/Engagement_Tool-Celebrate_Every_Milestone.webp`)} loading='lazy' alt="Celebrate Every Milestone!" width="500" height="561"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="section-heading-top cursive">
                <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat8">Unleash the Strength of &nbsp;<span className="charmonman green-clr">Community</span></Trans>&nbsp;!</h2>
                <div className="section-para text-center"><Trans>Experience the collective power of wellness through engaging, competing, and celebrating <br/>achievements among peers.</Trans></div>
            </div>
        </section>

        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Join the Wellness Movement Today!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 text-white">
                        <Trans>Experience the magic of connection, competition, and celebration.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Let's Talk</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default EngagementTools
